// extracted by mini-css-extract-plugin
export default {"message":"Messages-message-dut","inline":"Messages-inline-24J","title":"Messages-title-L7Z","text":"Messages-text-10L"};